export default [
    {
        name: 'personal',
        title: '我的中心',
        component: () => import(/* webpackChunkName: "personal" */ '../views/Personal/Index/index')
    },
    {
        name: 'messageCenter',
        title: '我的消息',
        component: () =>
            import(/* webpackChunkName: "messageCenter" */ '../views/MessageCenter/index')
    },
    {
        name: 'friendPersonal',
        title: '好友中心',
        // redirect: '/personal'
        component: () => import('../views/Personal/Index/friend')
        // component: () => import('../views/Personal/Friend/index'),
    },
    {
        name: 'fans',
        title: '我的中心',
        component: () => import(/* webpackChunkName: "fans" */ '../views/Personal/Fans/index')
    },
    {
        name: 'hallDataPersonal',
        title: '攀岩馆数据',
        component: () =>
            import(/* webpackChunkName: "hallDataPersonal" */ '../views/Personal/Data/hall')
    },
    {
        name: 'fieldDataPersonal',
        title: '攀岩场数据',
        component: () =>
            import(/* webpackChunkName: "fieldDataPersonal" */ '../views/Personal/Data/field')
    },
    {
        name: 'chat',
        title: '聊天信息',
        component: () => import(/* webpackChunkName: "chat" */ '../views/MessageCenter/chat')
    },
    {
        name: 'fieldCare',
        title: '岩场',
        component: () =>
            import(/* webpackChunkName: "fieldCare" */ '../views/Personal/field/fieldCare.vue')
    },
    {
        name: 'qingdanCare',
        title: '线路清单',
        component: () =>
            import(/* webpackChunkName: "qingdanCare" */ '../views/Personal/field/qingdanCare.vue')
    },
    {
        name: 'dongtaiCare',
        title: '动态',
        component: () =>
            import(/* webpackChunkName: "dongtaiCare" */ '../views/Personal/dongTai/index.vue')
    },
    {
        name: 'betaCare',
        title: 'beta',
        component: () =>
            import(/* webpackChunkName: "betaCare" */ '../views/Personal/Index/betaCare.vue')
    }
]
